import { Dispatch, SetStateAction } from 'react';
import { Box, Button } from '@nimbus-ds/components';
import SubmitButton from 'commons/components/SubmitButton/SubmitButton';
import { PersonalDataState } from 'domains/PagoNubeOnboarding/Onboarding/types';
import useUpdateRecipient from 'domains/PagoNubeOnboarding/Recipient/hooks/useUpdateRecipient';
import { mapPersonalDataToRecipient } from 'domains/PagoNubeOnboarding/Recipient/utils';
import useTranslationPagoNubeOnboarding from 'domains/PagoNubeOnboarding/useTranslationPagoNubeOnboarding';
import { useStoreInfo } from 'domains/PartnersApps/hooks';

interface SaveAndContinueButtonsProps {
  onSubmit: () => void;
  personalDataState: PersonalDataState;
  setIsSaveAndContinueBtnClicked: Dispatch<SetStateAction<boolean>>;
}

function SaveAndContinueButtons({
  onSubmit,
  personalDataState,
  setIsSaveAndContinueBtnClicked,
}: Readonly<SaveAndContinueButtonsProps>) {
  const t = useTranslationPagoNubeOnboarding('saveAndContinueButtons');

  const { isLoading, updateRecipient } = useUpdateRecipient();
  const { id: storeId } = useStoreInfo();

  const handleSaveAndContinue = () => {
    if (!isLoading) {
      setIsSaveAndContinueBtnClicked(true);
      const recipient = mapPersonalDataToRecipient(personalDataState);
      updateRecipient(storeId, { ...recipient });
    }
  };

  return (
    <Box alignItems="center" display="flex" justifyContent="flex-end" gap="4">
      <Button
        appearance="neutral"
        aria-label={t('saveAndExit')}
        onClick={handleSaveAndContinue}
        disabled={isLoading}
      >
        {t('saveAndExit')}
      </Button>
      <SubmitButton
        appearance="primary"
        aria-label={t('sendForm')}
        onClick={onSubmit}
        isLoading={isLoading}
      >
        {t('send')}
      </SubmitButton>
    </Box>
  );
}

export default SaveAndContinueButtons;
